function SvgBook({ color = "#0055FF", width = 20, height = 20, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.33203 16.2493C3.33203 15.6968 3.55152 15.1669 3.94223 14.7762C4.33293 14.3855 4.86283 14.166 5.41536 14.166H16.6654M3.33203 16.2493C3.33203 16.8019 3.55152 17.3318 3.94223 17.7225C4.33293 18.1132 4.86283 18.3327 5.41536 18.3327H16.6654V1.66602H5.41536C4.86283 1.66602 4.33293 1.88551 3.94223 2.27621C3.55152 2.66691 3.33203 3.19681 3.33203 3.74935V16.2493Z"
        stroke={color || color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgBook;
